import { Route } from '@angular/router';
import { ProjectInsightsComponent } from './insights.component';
import { ProjectInsightsMarketComponent } from './market/market.component';
import { ProjectInsightsRecordsComponent } from './records/records.component';
import { ProjectInsightsCompsComponent } from './comps/comps.component';
import { ProjectInsightsAnalyticsComponent } from './analytics/analytics.component';
import { ProjectDataResolver, ProjectsFieldDefsResolver } from 'app/modules/projects/projects.resolvers';
import {
  ProjectInsightsPropertyResolver,
  ProjectInsightsPropertiesResolver,
  ProjectInsightsCompsetsResolver,
  ProjectInsightsCompsetResolver,
} from 'app/modules/projects/details/insights/insights.resolvers';
import { ResearchDataResolver } from 'app/modules/research/research.resolvers';

export const insightsRoutes: Route[] = [
  {
    path: '',
    component: ProjectInsightsComponent,
    resolve: {
      properties: ProjectInsightsPropertiesResolver,
    },
    children: [
      {
        path: ':property_id/market',
        component: ProjectInsightsMarketComponent,
        resolve: {
          property: ProjectInsightsPropertyResolver,
          options: ResearchDataResolver,
          compsets: ProjectInsightsCompsetsResolver,
        },
      },
      {
        path: ':property_id/records',
        component: ProjectInsightsRecordsComponent,
        resolve: {
          property: ProjectInsightsPropertyResolver,
          options: ResearchDataResolver,
          compsets: ProjectInsightsCompsetsResolver,
        },
      },
      {
        path: ':property_id/comps/:id',
        component: ProjectInsightsCompsComponent,
        resolve: {
          property: ProjectInsightsPropertyResolver,
          options: ProjectDataResolver,
          fieldDefs: ProjectsFieldDefsResolver,
          compsets: ProjectInsightsCompsetsResolver,
          compset: ProjectInsightsCompsetResolver,
        },
      },
      {
        path: ':property_id/analytics',
        children: [
          {
            path: '',
            loadChildren: () =>
              import('app/shared/modules/time-series-charts/time-series-charts.module').then(
                (m) => m.TimeSeriesChartsModule,
              ),
          },
        ],
      },
    ],
  },
];
